var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isAndroidMode())?_c('div',{staticClass:"videocomponent",class:{'portrait': _vm.portrait}},[_c('video',{ref:"video",class:{'portrait': _vm.portrait},attrs:{"autoplay":""}}),_vm._v(" "),_c('div',{ref:"detectionFrame",staticClass:"detection-frame",class:{'portrait': _vm.portrait}}),_vm._v(" "),_c('canvas',{ref:"canvasRec"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d26c8a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AIFaceVideoComponent.vue
// module id = null
// module chunks = 